import { View, Text, TextInput, Pressable, ImageBackground } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import GlobalStyles from './../style';
import AsyncStorage from '@react-native-async-storage/async-storage';
import alert from './../alert'
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const DownloadTeam = () => {
  let [teamData, onChangeTeamData] = React.useState("");

  const navigation = useNavigation();
  useLayoutEffect(() => {
      navigation.setOptions({
          //headerShown: false,
          headerTitle: transl('MainMenu.importarAmigo', lang)
      })
  }, []);

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
    })
  }
  readValue();

  lang = dr.idiomas[useSelector((state) => state.language)].value

  return (
    <ImageBackground source={require('./../img/background4.png')} resizeMode="cover" style={{ flex: 1 }}>
      <View style={{ marginTop: 'auto', marginBottom: 'auto' }}>
        <Text style={{ marginHorizontal: 10, marginTop: 25 }}>{transl('DownloadFriend.copiaAquiLosDatos', lang)}</Text>
        <View style={[GlobalStyles.buttonMargins]}>
          <Text style={{ textAlign: 'center' }}>{transl('DownloadFriend.datos', lang)}</Text>
          <TextInput
            style={[GlobalStyles.input, {backgroundColor:'white'}]}
            onChangeText={onChangeTeamData}
            value={teamData}
          />
          <View style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <Pressable
              style={GlobalStyles.buttonMain}
              onPress={() => {
                importData(teamData, value, navigation)
              }
              }>
              <Text style={GlobalStyles.textForButtonMain}>{transl('DownloadFriend.importTheTeam', lang)}</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </ImageBackground>
  )
}

function importData(teamData,value,navigation){
  let existe = false;
  try{
    let CryptoJS = require("crypto-js");
    let bytes = CryptoJS.AES.decrypt(teamData, 'quidditch');
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
  
    //parse friendteam data
    if(plaintext === undefined || !plaintext) {
      alert(transl('General.error', lang),transl('DownloadFriend.noSeHanPodido', lang),[
        {text: transl('General.OK', lang),onPress: () => void(0), style: "cancel"},
      ]);
      return
    }
    if(typeof plaintext != "object")plaintext = plaintext != null ? JSON.parse(plaintext) : null
  
    //parse myteam data
    if(value === undefined || !value) {
      return
    }
    if(typeof value != "object")value = value != null ? JSON.parse(value) : null
    
    let playersParsed = plaintext
  
    if(playersParsed.info.uuid == value.profile.uuid){
      alert(transl('General.error', lang),transl('DownloadFriend.noPuedesGuardar', lang),[
        {text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"
        }
      ]);
      return
    }
  
    console.log(playersParsed)
    teamData = playersParsed

    playersParsed.info.date = new Date();

    const existingIndex = value.multiplayer.teams.findIndex(item => item.info.uuid === playersParsed.info.uuid);
  
    if(existingIndex !== -1) {
      value.multiplayer.teams[existingIndex] = playersParsed;
      existe = true;
    } else value.multiplayer.teams.push(playersParsed);
  } catch (e){
    console.log(e)
    alert(transl('General.error', lang),transl('DownloadTeam.noSeHanPodido', lang),[
      {text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"},
    ]);
  }
  

  const storeData = async (value,playersParsed,navigation,existia) => {
    try {
      const jsonValue = JSON.stringify(value)
      await AsyncStorage.setItem('equipos', jsonValue)
      let typeAlert = transl('General.guardado', lang)
      let descriptionAlert = transl('DownloadFriend.equipoGuardadoCorrectamente', lang,[playersParsed.info.name])
      if(existia){
        typeAlert = transl('General.actualizado', lang)
        descriptionAlert = transl('DownloadFriend.equipoActualizadoCorrectamente', lang,[playersParsed.info.name])
      }
      alert(typeAlert,descriptionAlert,[
        {
          text: transl('General.OK', lang),
          onPress: () => navigation.navigate('FriendsList'),
          style: "cancel"
        }
      ])
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }
  storeData(value,teamData,navigation,existe)
}

export default DownloadTeam